// @flow
import { has, isEmpty } from 'lodash';

const PtatReceivers = {
  HOPPER2000: 'Hopper (XiP813)',
  HPR2000: 'Hopper (XiP813)',
  HOPPER2: 'Hopper with Sling (XiP913)',
  HPRSLNG: 'Hopper with Sling (XiP913)',
  HOPPER3: 'Hopper 3 (ZiP1018)',
};
const SideloadingReceivers = {
  HOPPER2: 'Hopper with Sling (XiP913)',
  HPRSLNG: 'Hopper with Sling (XiP913)',
  HOPPER3: 'Hopper 3 (ZiP1018)',
};

const NoLiveDvrReceivers = {
  VIP211: 'On Demand only account (VIP211)',
  VIP211K: 'On Demand only account (VIP211K)',
};

export const hasPtat = (receiverModel: string): boolean => has(PtatReceivers, receiverModel);

export const hasSideloading = (receiverModel: string): boolean =>
  has(SideloadingReceivers, receiverModel);

export const hasLiveDVR = (receiverModel: string): boolean =>
  !has(NoLiveDvrReceivers, receiverModel);

export const isVipReceiver = (receiverModel: string): boolean =>
  !isEmpty(receiverModel) && (receiverModel.startsWith('VIP') || receiverModel === 'HOPPERDUO');
